import { render, staticRenderFns } from "./SolicitudMedico.vue?vue&type=template&id=5c761353"
import script from "./SolicitudMedico.vue?vue&type=script&lang=js"
export * from "./SolicitudMedico.vue?vue&type=script&lang=js"
import style0 from "./SolicitudMedico.vue?vue&type=style&index=0&id=5c761353&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports